import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/dialog-close.png'


const _withScopeId = n => (_pushScopeId("data-v-b09a3f2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dialog-mask"
}
const _hoisted_2 = { class: "dialog-top" }
const _hoisted_3 = { class: "dialog-contnet" }

import { ref } from 'vue'

export default {
  __name: 'dialog',
  props: {
  modelValue: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    default: '默认标题'
  },
  size: {
    type: String, //默认 large 1000px  small 680px
    default: 'large'
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: emits }) {

const props = __props;




const closeDialog = () => {
  // emits['update:modelValue']
  emits('update:modelValue', false)
}


return (_ctx, _cache) => {
  return (__props.modelValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["dialog", __props.size=='large'? '' :'small'])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(__props.title), 1),
            _createElementVNode("img", {
              class: "curPointer",
              src: _imports_0,
              alt: "",
              onClick: closeDialog
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

}